import React from 'react'
import PropTypes from 'prop-types'
import { Form, Button, Level } from '@deseretbook/react-ui'
import { AddressFormManager, AddressFormFields } from '../forms'

/**
 * Address form, primarily used in checkout process.
 */
const AddressForm = ({
  address,
  onSubmit,
  onChange,
  isSubmitting,
  saveButtonText,
  onCancel,
}) => (
  <AddressFormManager address={address} onChange={onChange}>
    {(addressFormProps) => {
      const { isFetchingData } = addressFormProps

      return (
        <Form onSubmit={onSubmit} isSubmitting={isSubmitting}>
          <AddressFormFields {...addressFormProps} />

          <Level>
            <Level.Right>
              {
                onCancel
                  ? (
                    <Level.Item>
                      <Button
                        type="button"
                        disabled={isFetchingData || isSubmitting}
                        onClick={onCancel}
                      >
                        Cancel
                      </Button>
                    </Level.Item>
                  )
                  : null
              }
              <Level.Item>
                <Form.SubmitButton
                  color="action"
                  disabled={isFetchingData}
                >
                  {saveButtonText}
                </Form.SubmitButton>
              </Level.Item>
            </Level.Right>
          </Level>
        </Form>
      )
    }}
  </AddressFormManager>
)

AddressForm.propTypes = {
  // Address data.
  address: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    address3: PropTypes.string,
    city: PropTypes.string,
    countryId: PropTypes.number,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    phone: PropTypes.string,
    stateId: PropTypes.number,
    stateName: PropTypes.string,
    zipcode: PropTypes.string,
  }),
  // Text to display inside the submit button.
  saveButtonText: PropTypes.string,
  // callback for when the address changes.
  onChange: PropTypes.func,
  // callback for when the form should be cancelled.
  onCancel: PropTypes.func,
  // Callback for when the form is to be submitted.
  onSubmit: PropTypes.func,
  // If the onSubmit callback is currently running.
  isSubmitting: PropTypes.bool,
}

AddressForm.defaultProps = {
  address: {},
  saveButtonText: 'Save Address',
  onChange: () => {},
  onCancel: null,
  onSubmit: () => {},
  isSubmitting: false,
}

export default AddressForm
